import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { MovieCard } from "@/components/MovieCard";

export const MovieRow = ({ title, movies, testid }) => {
  const ref = useRef(null);
  if (!movies || movies.length === 0) return null;

  const scroll = (dir) => {
    if (ref.current) {
      const scrollAmount = ref.current.clientWidth * 0.75 * dir;
      ref.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <section className="my-10 md:my-14 lg:my-16" data-testid={testid}>
      <div className="flex items-center justify-between px-6 md:px-16 mb-5">
        <h2 className="font-heading text-lg sm:text-xl md:text-2xl font-bold tracking-tight text-white flex items-center gap-2">
          <span>{title}</span>
          <span className="text-xs font-semibold bg-zinc-800/80 text-zinc-400 px-2 py-0.5 rounded-full border border-white/5">
            {movies.length}
          </span>
        </h2>
      </div>

      <div className="group/row relative">
        {/* Left Scroll Button */}
        <button
          onClick={() => scroll(-1)}
          className="absolute left-2 top-1/2 -translate-y-1/2 z-30 w-11 h-11 rounded-full bg-black/80 border border-white/15 backdrop-blur-md items-center justify-center hidden md:group-hover/row:flex text-white hover:bg-[#E11D48] hover:border-[#E11D48] shadow-xl transition-all"
          aria-label={`Desplazar hacia la izquierda en ${title}`}
        >
          <ChevronLeft size={24} />
        </button>

        {/* Scrollable Container */}
        <div
          ref={ref}
          className="flex items-start gap-4 sm:gap-5 overflow-x-auto no-scrollbar px-6 md:px-16 py-3 scroll-smooth snap-x snap-mandatory"
        >
          {movies.map((m) => (
            <div key={m.id} className="snap-start shrink-0 flex-shrink-0 w-[140px] sm:w-[165px] md:w-[185px]">
              <MovieCard movie={m} progress={m.progress} className="w-full" />
            </div>
          ))}
        </div>

        {/* Right Scroll Button */}
        <button
          onClick={() => scroll(1)}
          className="absolute right-2 top-1/2 -translate-y-1/2 z-30 w-11 h-11 rounded-full bg-black/80 border border-white/15 backdrop-blur-md items-center justify-center hidden md:group-hover/row:flex text-white hover:bg-[#E11D48] hover:border-[#E11D48] shadow-xl transition-all"
          aria-label={`Desplazar hacia la derecha en ${title}`}
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </section>
  );
};

